export const PROVIDER_LOAD_DEFAULT_PROVIDER = 'PROVIDER_LOAD_DEFAULT_PROVIDER';
export const PROVIDER_LOAD_PROVIDER_WITH_NAME_FAILURE = 'PROVIDER_LOAD_PROVIDER_WITH_NAME_FAILURE';
export const PROVIDER_LOAD_PROVIDER_WITH_NAME_REQUEST = 'PROVIDER_LOAD_PROVIDER_WITH_NAME_REQUEST';
export const PROVIDER_LOAD_PROVIDER_WITH_NAME_SUCCESS = 'PROVIDER_LOAD_PROVIDER_WITH_NAME_SUCCESS';
